import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { useNavigate } from "react-router-dom";
import { Users, Zap, Trophy } from "lucide-react";
import MyLinkCard from "../components/MyLinkCard";
import ConnectStripeCard from "../components/ConnectStripeCard";
import { useContent } from "../lib/content";

export default function Affiliation() {
  const { user } = useAuth();
  const { c } = useContent();
  const tiers = [...(c.tiers || [])].map((t, i) => ({ ...t, i, min: Number(t.min) || 0 })).sort((a, b) => a.min - b.min);
  const [data, setData] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    if (!user) return;
    api.get("/referral/me").then(r => setData(r.data));
  }, [user]);
  if (!user) {
    return (
      <div className="max-w-xl mx-auto px-4 py-24 text-center">
        <div className="label-mono text-neon mb-2">{c.aff_label}</div>
        <h1 className="font-display text-4xl mb-4 whitespace-pre-line">{c.aff_title}</h1>
        <p className="text-neutral-400 mb-6">{c.aff_guest_text}</p>
        <button onClick={()=>nav("/register")} className="btn-primary" data-testid="aff-register">REGISTRATI</button>
      </div>
    );
  }
  if (!data) return <div className="p-16 text-center text-neutral-500 font-mono">LOADING...</div>;

  const currentTierIdx = tiers.findIndex(t=>t.name === data.tier);
  const nextTier = tiers[currentTierIdx+1];
  const progress = nextTier && nextTier.min > 0 ? Math.min(100, (data.credits/nextTier.min)*100) : 100;

  return (
    <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-16">
      <div className="label-mono text-neon mb-2">{c.aff_label}</div>
      <h1 className="font-display text-4xl lg:text-6xl mb-10 whitespace-pre-line">{c.aff_title}</h1>

      <div className="grid lg:grid-cols-3 gap-5 mb-10">
        <div className="lg:col-span-2 space-y-5">
          <MyLinkCard code={data.code} title="IL TUO LINK PERSONALE"/>
          <ConnectStripeCard/>
        </div>

        <div className="card-dark p-6 flex flex-col items-center text-center">
          <Trophy className="w-10 h-10 text-neon mb-2"/>
          <div className="label-mono mb-1">TIER ATTUALE</div>
          <div className="font-display text-3xl text-neon" data-testid="ref-tier">{data.tier}</div>
          <div className="font-mono text-xs text-neutral-500 mt-2">{data.credits} CREDITI</div>
          {nextTier && (
            <div className="mt-4 w-full">
              <div className="h-1 bg-neutral-900">
                <div className="h-full bg-neon" style={{width: `${progress}%`}}/>
              </div>
              <div className="label-mono text-[9px] mt-2">{nextTier.min - data.credits} crediti → {nextTier.name}</div>
            </div>
          )}
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-5 mb-14">
        <StatCard icon={Users} label="REFERRED" value={data.referred_users}/>
        <StatCard icon={Zap} label="PERSONE IN LISTA" value={data.list_signups}/>
        <StatCard icon={Trophy} label="CREDITI ACCUMULATI" value={data.credits}/>
      </div>

      <div className="label-mono text-alert mb-4">// TIER_LADDER</div>
      <div className="grid md:grid-cols-4 gap-4">
        {tiers.map(t => (
          <div key={`${t.i}-${t.name}`} className={`card-dark p-5 ${t.name===data.tier?"border-neon":""}`} data-testid={`tier-${t.i}`}>
            <div className={`label-mono mb-2 ${t.name===data.tier?"text-neon":""}`}>{t.name}</div>
            <div className="font-display text-xl mb-2">{t.min}+ <span className="text-xs font-mono text-neutral-500">crediti</span></div>
            <p className="text-xs text-neutral-400">{t.perks}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

function StatCard({ icon: Icon, label, value }) {
  return (
    <div className="card-dark p-6 flex items-center gap-4">
      <Icon className="w-6 h-6 text-neon"/>
      <div>
        <div className="label-mono mb-1">{label}</div>
        <div className="font-display text-3xl">{value}</div>
      </div>
    </div>
  );
}
